import { Component, EventEmitter, Output, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'app-resume-popup',
  templateUrl: './resume-popup.component.html',
  styleUrls: ['./resume-popup.component.less', '../../shared/common.less']
})
export class ResumePopupComponent implements OnInit, OnChanges {
  @Output() isClosed = new EventEmitter<boolean>();
  @Output() sendAssessorKey = new EventEmitter<{}>();
  @Input() isResend = true;
  @Input() isAssessors = false;
  @Input() assessors = []
  @Input() suspendErrorMessage: Array<string> = ['', '', ''];
  @Input() suspendActiveAssessors: Array<{ email: string, code: string }> = []; 
  isResumeReady = false;
  otpCodes: string[] = []

  constructor(public common: Common) {}

  checkIfResumeReady() {
    if (this.suspendActiveAssessors.length >= (this.assessors.length - 1)) {
      this.isResumeReady = true;
    } else {
      this.isResumeReady = false;
    }
  }

  onCodeInput(value: string, index: number) {
    
    this.otpCodes[index] = value;
    
    if (value && value.length === 6) {
      this.sendAssessorKey.emit({ email: this.assessors[index].email, code: value, index: index });
    }
  }

  isAssessorActive(assessorEmail: string): boolean {
    return this.suspendActiveAssessors.some(active => active.email === assessorEmail);
  }
  
  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }

  ngOnInit() {
    this.checkIfResumeReady();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['suspendActiveAssessors'] || changes['assessors']) {
      this.checkIfResumeReady();
    }
  }

}
